export var ShotLogEntryType;
(function (ShotLogEntryType) {
    ShotLogEntryType["GoodTake"] = "goodtake";
    ShotLogEntryType["OkTake"] = "oktake";
    ShotLogEntryType["BadTake"] = "badtake";
})(ShotLogEntryType || (ShotLogEntryType = {}));
